export const isDecimal = (number: number): boolean => `${number}`.includes('.');

export const getNumericFormatTypeComparator =
  ([int, decimal]: string[]) =>
  (number: number) =>
    isDecimal(number) ? decimal : int;
